Ext.define('SA.lq.view.Condition', {
    alias: 'widget.lq-condition',
    extend: 'SA.view.SimpleContainer',

    items: [
        {
            xtype: 'simple-container',
            cls: 'sa-lq-condition-upper-container',

            items: [
                {
                    xtype: 'simple-container',
                    cls: 'sa-lq-condition-attribute-label-container',

                    items: [
                        {
                            xtype: 'component',
                            cls: 'sa-lq-condition-attribute-label',
                            itemId: 'attributeLabelCmp'
                        }
                    ]
                }, {
                    xtype: 'combo-button',
                    cls: 'sa-lq-condition-condition-operator-combo',
                    itemId: 'conditionOperatorCombo',
                    textField: 'text',
                    valueField: 'value',

                    items: [
                        {
                            text: 'is greater than',
                            value: '>'
                        }, {
                            text: 'is less than',
                            value: '<'
                        }, {
                            text: 'is equal to',
                            value: '='
                        }, {
                            text: 'is greater than or equal to',
                            value: '>='
                        }, {
                            text: 'is less than or equal to',
                            value: '<='
                        }, {
                            text: 'is not equal to',
                            value: '<>'
                        }, {
                            text: 'is between',
                            value: 'between'
                        }
                    ]
                }, {
                    xtype: 'simple-container',
                    cls: 'sa-lq-condition-fields-container',

                    items: [
                        {
                            xtype: 'sa-formatted-numberfield',
                            cls: 'sa-lq-condition-field',
                            enableKeyEvents: true,
                            itemId: 'unaryField',
                            maskRe: /[\d.$,\-%]/
                        }, {
                            xtype: 'simple-container',
                            cls: 'sa-lq-condition-between-fields-container',
                            hidden: true,
                            itemId: 'betweenFieldsContainer',

                            items: [
                                {
                                    xtype: 'sa-formatted-numberfield',
                                    cls: 'sa-lq-condition-field',
                                    enableKeyEvents: true,
                                    itemId: 'gteField',
                                    maskRe: /[\d.$,\-%]/,

                                    listeners: {
                                        blur: field => field.up('lq-condition').onGteFieldBlur()
                                    }
                                }, {
                                    xtype: 'sa-formatted-numberfield',
                                    cls: 'sa-lq-condition-field',
                                    enableKeyEvents: true,
                                    itemId: 'lteField',
                                    maskRe: /[\d.$,\-%]/,

                                    listeners: {
                                        blur: field => field.up('lq-condition').onLteFieldBlur()
                                    }
                                }
                            ]
                        }
                    ]
                }, {
                    xtype: 'remove-button',
                    cls: 'sa-lq-condition-remove-btn',
                    itemId: 'removeBtn'
                }
            ]
        }, {
            xtype: 'divider-combo-button',
            cls: 'sa-lq-condition-list-operator-divider-combo',
            itemId: 'listOperatorCombo',
            items: ['and', 'or']
        }
    ],

    getAttributeId() {
        return this.attributeId;
    },

    getConditionOperatorValue() {
        return this.conditionOperatorCombo.getValue();
    },

    getGteValue() {
        return this.gteField.getValue();
    },

    getListOperatorValue() {
        return this.listOperatorCombo.getValue();
    },

    getLteValue() {
        return this.lteField.getValue();
    },

    getUnaryOperandValue() {
        return this.unaryField.getValue();
    },

    hasBetweenOperator() {
        return this.getConditionOperatorValue() === 'between';
    },

    onGteFieldBlur() {
        if (!this.hasBetweenOperator()) {
            return;
        }

        const gteValue = this.getGteValue();
        const lteValue = this.getLteValue();

        if (gteValue >= lteValue) {
            const incrementedValue = gteValue + 1;
            this.lteField.setValue(incrementedValue);
        }
    },

    onLteFieldBlur() {
        if (!this.hasBetweenOperator()) {
            return;
        }

        const gteValue = this.getGteValue();
        const lteValue = this.getLteValue();

        if (gteValue >= lteValue) {
            const decrementedValue = Math.max(lteValue - 1, 0);
            this.gteField.setValue(decrementedValue);
        }
    },

    onOperatorComboChange(value) {
        if (value === 'between') {
            let gteValue = this.getUnaryOperandValue(),
                lteValue = Number.isFinite(gteValue) ? (gteValue + 1) : null;

            this.setIsBetweenCondition([gteValue, lteValue]);
        }
        else if (this.betweenFieldsContainer.isVisible()) {
            this.setIsUnaryCondition({operator: value, operand: this.getGteValue()});
        }

        this.fireEvent('operatorComboChange');
    },

    sameState(otherCmp) {
        if (!otherCmp) {
            return false;
        }

        return this.getListOperatorValue() === otherCmp.getListOperatorValue()
            && this.getConditionOperatorValue() === otherCmp.getConditionOperatorValue()
            && this.getAttributeId() === otherCmp.getAttributeId()
            && this.getGteValue() === otherCmp.getGteValue()
            && this.getLteValue() === otherCmp.getLteValue()
            && this.getConditionOperatorValue() === otherCmp.getConditionOperatorValue()
            && this.getUnaryOperandValue() === otherCmp.getUnaryOperandValue();
    },

    setIsBetweenCondition([gteValue, lteValue]) {
        this.conditionOperatorCombo.setValueUnevented('between');

        this.unaryField.hide();
        this.betweenFieldsContainer.show();

        this.unaryField.setValueUnevented(null);
        this.gteField.setValueUnevented(gteValue);
        this.lteField.setValueUnevented(lteValue);
    },

    setIsUnaryCondition({operator, operand}) {
        this.conditionOperatorCombo.setValueUnevented(operator);

        this.unaryField.show();
        this.betweenFieldsContainer.hide();

        this.unaryField.setValueUnevented(operand);
        this.gteField.setValueUnevented(null);
        this.lteField.setValueUnevented(null);
    },

    setListOperatorValue(value) {
        this.listOperatorCombo.setValueUnevented(value);
    }
});